import * as stylex from "@stylexjs/stylex";
import { colors, fonts, fontSizes } from "@softmax/design-system/tokens.stylex";
import type { ComponentPropsWithoutRef } from "react";

export function StoreLink({
  children,
  tone = "quiet",
  align = "inline",
  ...props
}: Omit<ComponentPropsWithoutRef<"a">, "className" | "style"> & {
  readonly tone?: "quiet" | "row";
  readonly align?: "inline" | "end";
}) {
  return (
    <a
      {...props}
      {...stylex.props(
        styles.link,
        tone === "row" && styles.rowLink,
        align === "end" && styles.alignEnd,
      )}
    >
      {children}
    </a>
  );
}

const styles = stylex.create({
  link: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: 1.385,
    color: { default: colors.subtle, ":hover": colors.foreground },
    textDecorationLine: { default: "none", ":hover": "underline" },
    textUnderlineOffset: 3,
    textDecorationColor: colors.borderStrong,
    outlineOffset: 3,
  },
  rowLink: { color: colors.foreground },
  alignEnd: { alignSelf: "flex-end" },
});
